import { apiClient, type ApiResponse } from '../../../api/axios';

export interface InternalMessage {
    id: string;
    message: string;
    senderName: string;
    senderUserId?: string;
    sendDateTime: string;
    receiverUserId?: string;
    receiverName?: string;
    submissionId?: string;
}

export interface SendMessagePayload {
    submissionId: string;
    receiverId: string; // User IDs separated by comma
    message: string;
}

export interface PrimaFacieSubmission {
    id: string;
    submissionNumber: string;
    title: string;
    authors: string;
    submittedAt: string;
    status: string;
    categoryName?: string;
}

export const communicationService = {
    // Get submissions that have undergone Prima Facie
    getSubmissionsByPrimaFacie: async (page = 1, pageSize = 10, search = ''): Promise<ApiResponse> => {
        const payload = {
            pageNumber: page,
            pageSize: pageSize,
            sortBy: 'submittedAt',
            sortDescending: true,
            search: search,
            completed: true
        };
        const response = await apiClient.post('/Submissions/GetSubmissionByPrimaFacie', payload);
        return response.data;
    },

    // Get message history for a submission
    getMessageHistory: async (submissionId: string, page = 1, pageSize = 20): Promise<ApiResponse<InternalMessage[]>> => {
        const response = await apiClient.get(`/SubmissionCommunications/${submissionId}/messages?page=${page}&pageSize=${pageSize}`);
        return response.data;
    },

    // Send an internal message
    sendMessage: async (payload: SendMessagePayload): Promise<ApiResponse<InternalMessage>> => {
        const response = await apiClient.post('/SubmissionCommunications/send', payload);
        return response.data;
    },

    // Get initial unread messages
    getInitialUnread: async (): Promise<ApiResponse<InternalMessage[]>> => {
        const response = await apiClient.get('/SubmissionCommunications/InitialUnread');
        return response.data;
    },

    // Mark submission thread as read
    markAsRead: async (submissionId: string): Promise<ApiResponse<boolean>> => {
        const response = await apiClient.get(`/SubmissionCommunications/MarkSubmissionThreadAsRead?submissionId=${submissionId}`);
        return response.data;
    }
};
